import { PageShell } from "@/components/PageShell";
import { useLang } from "@/i18n";

const SECTIONS = [
  ["Chi tratta i tuoi dati", "Il titolare del trattamento è TripSaver (tripsaver.it). Per qualsiasi richiesta sulla privacy puoi rispondere a una delle email ricevute da TripSaver."],
  ["Quali dati raccogliamo", "L'indirizzo email che inserisci per ricevere l'itinerario, le richieste di viaggio e gli itinerari generati, i dati dell'account se ti registri (nome, email) e dati di navigazione anonimi raccolti tramite cookie di analisi."],
  ["Perché li usiamo", "Per inviarti l'itinerario richiesto, per mandarti in futuro consigli di viaggio sostenibile (solo se hai dato il consenso), per gestire il tuo account e per migliorare il servizio."],
  ["Base giuridica", "Il consenso che esprimi spuntando la casella, che puoi revocare in qualsiasi momento, e l'esecuzione del servizio che ci richiedi."],
  ["Servizi di terze parti", "Usiamo un fornitore di invio email, Google Analytics per statistiche di traffico e Travelpayouts per i link verso Skyscanner e Booking.com. Questi servizi possono usare cookie secondo le proprie informative."],
  ["Per quanto tempo", "Conserviamo la tua email finché non revochi il consenso. Gli itinerari restano disponibili tramite il loro link finché non vengono eliminati."],
  ["I tuoi diritti", "Puoi chiedere accesso, rettifica, cancellazione, limitazione, portabilità dei tuoi dati e revocare il consenso rispondendo a una nostra email. Puoi anche presentare reclamo all'autorità di controllo (in Italia il Garante per la protezione dei dati personali)."],
];

export default function Privacy() {
  const { t } = useLang();
  return (
    <PageShell testId="privacy-page" eyebrow={t("Informativa")} title={t("Privacy policy")}>
      <div className="max-w-3xl space-y-8 rounded-3xl border border-emerald-100 bg-white p-8 md:p-12">
        {SECTIONS.map(([title, body], i) => (
          <section key={title} data-testid={`privacy-section-${i}`}>
            <h2 className="font-display text-lg font-semibold text-gray-900">{t(title)}</h2>
            <p className="mt-2 leading-relaxed text-gray-600">{t(body)}</p>
          </section>
        ))}
        <p className="text-xs text-gray-400">{t("Ultimo aggiornamento: giugno 2026")}</p>
      </div>
    </PageShell>
  );
}
